import React, { useState, useEffect } from 'react';
import { useSelector, useIntl, getLocale } from 'umi';
import { Card, notification, Bubble, ConfigProvider, Row, Col, Pagination } from 'tea-component';
import SvgIcon from '../../SvgIcon';
import HeaderRight from './components/HeaderRight';
import CardItem from './components/CardItem';
import Intelligence from './components/Intelligence';
import Opinion from './components/Opinion';
import Competitor from './components/Competitor';
import LodingData from './components/LodingData';
import {
  getKeyPerformanceMetrics,
  getSearchCardIntelligence,
  getSearchCardOpinion,
  fetchGameIfFollowing,
  fetchGameSetFollowing,
  fetchFeedbackSearchResult,
} from '@/pages/home/services/search';
import {
  turnCardInfoDataList,
  getSearchResultCardList,
  getSearchPageParams,
  updateSearchPageUrl,
} from '@/pages/home/utils/search';
import { getTeaLocale } from '@/pages/home/utils/lang';
import { LANGUAGE_CN, IS_GLOBAL } from '@/pages/home/_config/config';
import { gotoDashboardGame, gotoIntelligenceGame, gotoOpinionGame } from '@/pages/home/utils/utils';
import NoData from '@/pages/intelligence/components/NoData';
import SearchNoData from './components/NoData';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { useDebounceEffect } from 'ahooks';
import { OPINIONFEEDSGAMES, ENTITY_TYPE_GP } from '@/pages/home/components/NavHeader/_config';

export default function SearchDetails(props: any) {
  const {
    searchResultList = [],
    searchResultTotal,
    currentItem = {},
    setCurrentItem,
    searchTime = '',
    setIfReloadUrl,
    addSearchHistory,
    srParamsPage,
    srParamsPageSize,
    children,
    handleClickBack,
    searchLoading,
    intelligenceLoading = false,
    setIntelligenceLoading,
    searchType = 'all',
    searchTypeHandle,
    isWhiteCompany = false,
    setForceSearch,
  } = props;

  const searchText = getSearchPageParams().kw;
  const { formatMessage } = useIntl(); // 中英切换方法
  const [isGood, setGod] = useState(0);
  const [isAction, setIsAction] = useState('');
  const [cardList, setCardList] = useState([]);
  const [dataIntelligence, setDataIntelligence] = useState([]);
  const [dataDashboard, setDataDashboard] = useState([]);
  const [cardInfoDataList, setCardInfoDataList] = useState([]);
  const [dataOpinion, setDataOpinion] = useState({} as any);
  const [competitorList, setCompetitorList] = useState([]);
  const [isGetDashboard, setIsGetDashboard] = useState(false);
  const [opinionLoading, setOpinionLoading] = useState(false);
  // 是否收藏
  const [isFollowing, setIsFollowing] = useState(false);
  const [isFollowingInited, setIsFollowingInited] = useState(true);
  const [isFeedbackInited, setIsFeedbackInited] = useState(true);
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  // 是否显示点赞反馈提示
  const [isFeedbackGoodVisible, setIsFeedbackGoodVisible] = useState(false);
  // 是否显示点踩反馈提示
  const [isFeedbackBadVisible, setIsFeedbackBadVisible] = useState(false);
  const locale = getTeaLocale(getLocale());
  const localeValue = getLocale();
  const { resetFilterExtend, resetDetailFilterExtend } = useFilterExtend({});

  // 调用获取情报数据接口
  const getSearchCardIntelligenceHandle = async (item: any) => {
    setIntelligenceLoading?.(true);
    const intelligenceParams = {
      game_code: item?.game_code,
      game_id: item?.game_id,
      entity_type: item?.entity_type,
    };
    try {
      const result: any = await getSearchCardIntelligence(intelligenceParams);
      if (result.code === 0) {
        if (result.data) {
          if (result.data.Intelligence) {
            setDataIntelligence(result.data.Intelligence);
          }
          if (result.data.Intelligence) {
            setCompetitorList(result.data.competitor);
          }
        }
      }
    } catch (err) {
    } finally {
      setIntelligenceLoading?.(false);
    }
  };

  const handleGotoFollowingPage = () => {
    gotoIntelligenceGame('', 'following', '');
  };

  // 设置游戏是否收藏
  const setGameFollowing = async (item: any) => {
    setIsFollowingInited(false);
    const contextId = item.game_id || item.company_id || '';
    const newIsFollowing = !isFollowing;
    const followingParams = {
      entity_type: item.entity_type,
      game_company_id: contextId,
      is_collection: newIsFollowing,
      user_id: userInfo?.userid,
    };
    try {
      const result: any = await fetchGameSetFollowing(followingParams);
      if (result.code === 0) {
        setIsFollowing(newIsFollowing);
        let className = '';
        let description: React.ReactNode | string;
        if (newIsFollowing) {
          className = '';
          description = (
            <>
              {getLocale() !== LANGUAGE_CN ? (
                <span>
                  See your{' '}
                  <span
                    style={{ color: '#0076FF', cursor: 'pointer' }}
                    onClick={handleGotoFollowingPage}
                  >
                    Following
                  </span>{' '}
                  in intelligence
                </span>
              ) : (
                <span>
                  请到情报查看您的
                  <span
                    style={{ color: '#0076FF', cursor: 'pointer' }}
                    onClick={handleGotoFollowingPage}
                  >
                    收藏
                  </span>
                </span>
              )}
            </>
          );
        } else {
          className = 'no-close-icon';
          description = formatMessage({ id: 'dbh_unfollow_successful' });
        }
        notification.success({
          unique: true,
          className,
          description,
        });
      }
    } catch (err) {
      notification.error({
        unique: true,
        description: formatMessage({ id: 'dbh_operation_failed_network' }),
      });
    } finally {
      setIsFollowingInited(true);
    }
  };

  // 设置对搜索结果是否满意
  const handleFeedback = async (isgood: any) => {
    if (isFeedbackInited && isGood != isgood) {
      setIsFeedbackInited(false);
      const firstResult = searchResultList?.length > 0 ? searchResultList[0] : null;
      const feedbackParams = {
        system_id: 4,
        search_content: searchText || '',
        search_result: {
          u_id: firstResult?.game_id || '',
          name: firstResult?.entity_name || '',
        },
        search_feedback: isgood || null,
        ext_info:
          searchResultList?.map((item: any) => ({
            u_id: item.game_id,
            name: item.entity_name,
          })) || [],
        create_time: searchTime || '',
        feedback_suggestion: '',
        platform: 1,
      };
      try {
        const result: any = await fetchFeedbackSearchResult(feedbackParams);
        if (result.code === 0) {
          if (isgood == 1) {
            setIsFeedbackGoodVisible(true);
          } else {
            setIsFeedbackBadVisible(true);
          }
          setGod(isgood);
          setTimeout(() => {
            setIsFeedbackGoodVisible(false);
            setIsFeedbackBadVisible(false);
          }, 3000);
        }
      } catch (err) {
      } finally {
        setIsFeedbackInited(true);
      }
    }
  };

  // 查询游戏是否有收藏
  const getGameIfFollowing = async (item: any) => {
    const contextId = item.game_id || item.company_id || '';
    const followingParams = {
      user_id: userInfo?.userid,
      game_company_id: contextId,
    };
    try {
      const result: any = await fetchGameIfFollowing(followingParams);
      if (result.code === 0) {
        setIsFollowing(result.data === 'true');
        setIsFollowingInited(true);
      }
    } catch (err) {
    } finally {
    }
  };

  // 调用获取经分数据接口
  const getKeyPerformanceMetricsHandle = async (item: any) => {
    const dashboardParams = {
      game_code: item?.game_code || 'test',
      start_time: '2022-01-02', // 后端接口未使用此参数，暂定此时间
      end_time: '2022-01-02',
    };
    try {
      const dashboardData: any = await getKeyPerformanceMetrics(dashboardParams);

      if (dashboardData.code === 0) {
        if (dashboardData.data) {
          if (
            Array.isArray(dashboardData?.data?.card_list) &&
            dashboardData.data.card_list.length > 0
          ) {
            setIsGetDashboard(true);
            setDataDashboard(dashboardData.data?.card_list);
          } else {
            // 若此游戏没有经分数据，则调情报的数据
            getSearchCardIntelligenceHandle(item);
          }
        }
      }
    } catch (err) {
      getSearchCardIntelligenceHandle(item);
    } finally {
      setIntelligenceLoading?.(false);
    }
  };

  // 调用获取舆情数据接口
  const getSearchCardOpinionHandle = async (item: any) => {
    const opinionParams = {
      edition_unified_id: item?.game_id,
      id_type: item?.entity_type === 'mobile' ? 'unified_id' : 'edition_id',
      user_id: userInfo?.openid,
      entity_type: item?.entity_type,
    };
    try {
      const opinionData: any = await getSearchCardOpinion(opinionParams);
      if (opinionData.code === 0) {
        if (opinionData.data) {
          setDataOpinion(opinionData.data);
        } else {
          setDataOpinion({});
        }
      }
    } catch (err) {
    } finally {
      setOpinionLoading(false);
    }
  };

  // 查询选择游戏详细数据
  const getSearchGameData = async (item: any) => {
    // setCardLoading(true)
    setIntelligenceLoading?.(true);

    setIsGetDashboard(false);
    // 如果此游戏有经分权限，调取经分数据与舆情数据
    if (item?.game_code && item?.dashboard === 2) {
      getKeyPerformanceMetricsHandle(item);
      if (item?.opinion === 2) {
        setOpinionLoading(true);
        getSearchCardOpinionHandle(item);
      }
    } else {
      // 如果此游戏没有经分权限，调取跟报情报与舆情数据
      getSearchCardIntelligenceHandle(item);
      if (item?.opinion === 2) {
        setOpinionLoading(true);
        getSearchCardOpinionHandle(item);
      }
    }
    // 查询游戏是否有收藏
    getGameIfFollowing(item);
  };

  const selectCardItemHandle = (item: any) => {
    setIfReloadUrl(false);
    setIsAction(item.game_id || '');
    setCurrentItem({ ...item });
    updateSearchPageUrl({ ...getSearchPageParams(), unid: item.game_id });
    setIntelligenceLoading?.(true);
  };

  const handlePagitionChange = (args: any) => {
    setIfReloadUrl(true);
    setForceSearch(true);
    updateSearchPageUrl({
      ...getSearchPageParams(),
      page: args.pageIndex,
      pageSize: args.pageSize,
    });
  };

  // 针对拖拽,拖动结束在进行dispatch,阻止更新视图
  // 添加切换游戏时，防抖节流
  useDebounceEffect(
    () => {
      if (currentItem && Object.keys(currentItem).length > 0) {
        setIsAction(currentItem?.game_id || '');
        if (currentItem?.entity_type !== 'company' && currentItem?.entity_type !== ENTITY_TYPE_GP) {
          getSearchGameData(currentItem);
        }
      }
    },
    [currentItem],
    {
      wait: 500,
    },
  );

  useEffect(() => {
    const isEn = localeValue === 'en-US';
    setCardList(getSearchResultCardList(searchResultList, isEn));
  }, [searchResultList, localeValue]);

  useEffect(() => {
    setCardInfoDataList(
      turnCardInfoDataList(
        isGetDashboard,
        dataDashboard,
        dataIntelligence,
        currentItem?.entity_type || '',
      ),
    );
  }, [dataDashboard, dataIntelligence]);

  // 跳转到对应其他系统页面
  const gotoSystem = (type: string) => {
    const { game_id, game_code, entity_type, opinionGameId = '' } = currentItem;

    // 清空情报继承值
    resetFilterExtend?.();
    resetDetailFilterExtend?.();

    if (type == 'intelligence') {
      gotoIntelligenceGame(
        game_id,
        entity_type,
        entity_type === 'company' ? 'Summary' : 'overview',
      );
    } else if (type == 'opinion') {
      const opinionGameIdValue = opinionGameId !== '' ? opinionGameId : game_id;
      // 临时方案，针对Gloabl环境下，有以下三款游戏的舆情权限的用户，跳转到舆情Feeds页面
      if (IS_GLOBAL && OPINIONFEEDSGAMES?.includes(opinionGameIdValue)) {
        gotoOpinionGame(opinionGameIdValue, entity_type, 'unified_id', '', '/opinion/Feeds/Feeds');
      } else {
        gotoOpinionGame(
          opinionGameIdValue,
          entity_type,
          'unified_id',
          '',
          '/opinion/Overview/KeyMetrics',
        );
      }
    } else if (type == 'dashboard') {
      gotoDashboardGame(game_code);
    }
  };
  const handleClickCancel = () => {
    searchTypeHandle('all');
  };
  const opinionInfo = currentItem?.opinion_info;
  const opinionTimezone = (
    Array.isArray(opinionInfo)
      ? opinionInfo.find((item: any) => item?.timezone)?.timezone
      : opinionInfo?.timezone
  ) || undefined;
  const showDuneOpinionUtc =
    Boolean(dataOpinion.feeds_data_time) &&
    currentItem?.opinion === 2 &&
    Boolean(opinionTimezone);
  return (
    <Row>
      <Col>
        <Card>
          <Card.Body
            className="home-search-body"
            title={
              <div className="home-search-title" onClick={handleClickBack}>
                <SvgIcon type="left-pointing" className="home-search-icon" />
                {formatMessage({ id: 'dbh_back' })}
              </div>
            }
          >
            {children}
            {searchLoading ? (
              <div className="home-search-skeleton">
                <LodingData />
              </div>
            ) : (
              <>
                {searchType == 'company' && isWhiteCompany ? (
                  <div className={'dbh-mb-16'}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formatMessage({ id: 'dbh_home_report_first_step' }),
                      }}
                    ></span>
                    <a herf={'#'} onClick={handleClickCancel}>
                      {formatMessage({ id: 'dbh_cancel_small' })}
                    </a>
                    {formatMessage({ id: 'dbh_home_report_second_step' })}
                  </div>
                ) : null}
                {searchResultTotal > 0 ? (
                  <>
                    {cardList.map((e: any, i: any) => {
                      return (
                        <CardItem
                          isAction={isAction}
                          key={i}
                          data={e}
                          searchText={searchText}
                          addSearchHistory={addSearchHistory}
                          getChange={(item: any) => {
                            selectCardItemHandle(item);
                          }}
                        />
                      );
                    })}
                    {searchResultTotal > 10 ? (
                      <ConfigProvider locale={locale}>
                        <Pagination
                          className="home-search-pagination"
                          endJumpVisible={false}
                          pageSizeVisible={true}
                          pageSizeOptions={[10, 20]}
                          recordCount={searchResultTotal}
                          pageIndexVisible={true}
                          pageIndex={srParamsPage}
                          pageSize={srParamsPageSize}
                          onPagingChange={handlePagitionChange}
                        />
                      </ConfigProvider>
                    ) : (
                      <div className="tea-pagination home-search-pagination">
                        <div className="tea-pagination__state">
                          <span className="tea-pagination__text">
                            {formatMessage(
                              {
                                id: 'dbh_search_table_total',
                              },
                              {
                                total: searchResultTotal,
                              },
                            )}{' '}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="home-search-skeleton">
                    <SearchNoData />
                  </div>
                )}
              </>
            )}
          </Card.Body>
        </Card>
        <div className="home-search-goodtext">
          {formatMessage({ id: 'dbh_result_useful' })}
          <Bubble
            dark
            arrowPointAtCenter
            content={formatMessage({
              id: 'dbh_feedback_isgod_tips',
            })}
            visible={isFeedbackGoodVisible}
          >
            <i
              onClick={() => {
                handleFeedback(1);
              }}
              className={isGood == 1 ? 'home-search-goodaction' : 'home-search-goodbtn'}
            >
              <SvgIcon className="home-search-goodicon" type="very-good" />
            </i>
          </Bubble>
          <Bubble
            dark
            arrowPointAtCenter
            content={formatMessage({
              id: 'dbh_feedback_isgod_tips',
            })}
            visible={isFeedbackBadVisible}
          >
            <i
              onClick={() => {
                handleFeedback(2);
              }}
              className={isGood == 2 ? 'home-search-goodaction' : 'home-search-goodbtn'}
            >
              <SvgIcon className="home-search-goodicon" type="not-work" />
            </i>
          </Bubble>
        </div>
      </Col>
      <>
        {searchResultTotal > 0 ? (
          <>
            <Col span={8} className="home-search-right-box">
              {currentItem?.entity_type === 'company' ||
              currentItem?.entity_type === ENTITY_TYPE_GP ? (
                <>
                  {currentItem?.entity_type === ENTITY_TYPE_GP ? null : (
                    <div className="home-search-right-company">
                      <p>{formatMessage({ id: 'dbh_searching_company_preview' })}</p>
                      <p>{formatMessage({ id: 'dbh_searching_thanks_patience' })}</p>
                    </div>
                  )}
                </>
              ) : (
                <Card
                  className="home-search-right"
                  style={{
                    background: `url(${currentItem?.entity_image?.split('|')[0] || ''}) no-repeat`,
                  }}
                >
                  <Card.Body>
                    <>
                      {intelligenceLoading ? (
                        <LodingData
                          ifSearch={false}
                          loadingHeight={currentItem?.entity_type === 'company' ? 50 : 100}
                        />
                      ) : (
                        <>
                          <HeaderRight
                            currentItem={currentItem}
                            isFollowing={isFollowing}
                            isFollowingInited={isFollowingInited}
                            setGameFollowing={setGameFollowing}
                          />
                          <div
                            className="home-search-tip"
                            onClick={() => {
                              gotoSystem(isGetDashboard ? 'dashboard' : 'intelligence');
                            }}
                          >
                            {isGetDashboard
                              ? formatMessage({ id: 'dbh_dashboard' })
                              : formatMessage({ id: 'dbh_intelligence' })}
                            <SvgIcon type="arrow-right" className="home-search-arrow" />
                          </div>
                          <Row className="home-search-row">
                            {cardInfoDataList.map((e: any, i: any) => {
                              return (
                                <Col
                                  key={i}
                                  span={12}
                                  className={i % 2 === 0 ? 'evennum' : 'oddnum'}
                                >
                                  <Intelligence
                                    data={e}
                                    currentItem={currentItem}
                                    isGetDashboard={isGetDashboard}
                                  />
                                </Col>
                              );
                            })}
                          </Row>
                          {opinionLoading ? (
                            <LodingData ifSearch={false} loadingHeight={40} />
                          ) : (
                            <>
                              <div
                                className={
                                  currentItem?.opinion == 2
                                    ? 'home-search-tip'
                                    : 'home-search-normal'
                                }
                                style={
                                  showDuneOpinionUtc
                                    ? {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                      }
                                    : undefined
                                }
                                onClick={() => {
                                  if (currentItem?.opinion == 2) gotoSystem('opinion');
                                }}
                              >
                                <span
                                  style={
                                    showDuneOpinionUtc
                                      ? { display: 'inline-flex', alignItems: 'center' }
                                      : { display: 'contents' }
                                  }
                                >
                                  {formatMessage({ id: 'dbh_opinion' })}
                                  <span className="home-search-opinion-time">
                                    {dataOpinion.feeds_data_time &&
                                    currentItem?.opinion === 2
                                      ? `(${dataOpinion.feeds_data_time})`
                                      : ''}
                                  </span>
                                  <SvgIcon
                                    type="arrow-right"
                                    className="home-search-arrow"
                                  />
                                </span>
                                {showDuneOpinionUtc && (
                                    <span className="home-search-opinion-time">
                                      {`${opinionTimezone}`}
                                    </span>
                                  )}
                              </div>
                              {currentItem?.opinion === 1 || currentItem?.opinion === 0 ? (
                                <div
                                  className="intelligence"
                                  style={{
                                    boxSizing: 'border-box',
                                    height: '140px',
                                    margin: '0 -5px',
                                    textAlign: 'center',
                                  }}
                                >
                                  <NoData
                                    text={formatMessage({
                                      id:
                                        currentItem?.opinion == 1
                                          ? 'dbh_search_opinion_tip'
                                          : 'dbh_search_opinion_nodata',
                                    })}
                                  />
                                </div>
                              ) : (
                                <Opinion
                                  dataOpinion={dataOpinion}
                                  currentItem={currentItem}
                                  competitorList={competitorList}
                                />
                              )}
                              {intelligenceLoading ? (
                                <LodingData ifSearch={false} loadingHeight={40} />
                              ) : (
                                <>
                                  {competitorList?.length > 0 && (
                                    <Competitor
                                      dataOpinion={dataOpinion}
                                      currentItem={currentItem}
                                      competitorList={competitorList}
                                    />
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </>
        ) : null}
      </>
    </Row>
  );
}
